import { MOBILE_FULL_SCREEN_CUSTOM_STYLE, EXTERNAL_POPUP_STYLES, DEFAULTS, DESKTOP_FLY_OUT_MODAL_STYLES } from '../constants.js';
import { TOOLBARS, getModalStyles, BUTTON_TYPES, INSERT_PLUGIN_BUTTONS, decorateComponentWithProps, getBottomToolbarModalStyles } from 'wix-rich-content-editor-common';
import GiphyInsertModal from './giphyInsertModal.js';
import InsertPluginIcon from '../icons/InsertPluginIcon.js';
import 'wix-rich-content-common';
import 'react';
import '../giphyApiInputModal-41baafe8.js';
import 'prop-types';
import 'wix-rich-content-ui-components';
import '../style-inject.es-746bb8ed.js';
import './giphySelector.js';
import 'react-infinite-scroller';
import 'react-md-spinner';
import 'react-custom-scrollbars';
import '../giphyEmptyState-aa3b5112.js';
import '../icons/PoweredByGiphy.js';
import 'classnames';
import 'lodash';
import '../types.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const createInsertButtons = ({
  t,
  settings,
  isMobile
}) => {
  var _a, _b;
  const icon = ((_b = (_a = settings == null ? void 0 : settings.toolbar) == null ? void 0 : _a.icons) == null ? void 0 : _b.InsertPluginButtonIcon) || InsertPluginIcon;
  const modalStylesByToolbar = {
    [TOOLBARS.FOOTER]: isMobile ? getModalStyles({
      customStyles: MOBILE_FULL_SCREEN_CUSTOM_STYLE,
      fullScreen: true,
      isMobile
    }) : void 0,
    [TOOLBARS.INSERT_PLUGIN]: isMobile ? getModalStyles({
      customStyles: MOBILE_FULL_SCREEN_CUSTOM_STYLE,
      fullScreen: true,
      isMobile
    }) : getModalStyles({ customStyles: EXTERNAL_POPUP_STYLES, fullScreen: false, isMobile })
  };
  const buttonProps = {
    type: BUTTON_TYPES.MODAL,
    name: INSERT_PLUGIN_BUTTONS.GIF,
    tooltip: t("GiphyPlugin_InsertButton_Tooltip"),
    getIcon: () => icon,
    componentData: settings.componentDataDefaults || DEFAULTS,
    modalElement: decorateComponentWithProps(GiphyInsertModal, settings)
  };
  return [
    __spreadProps(__spreadValues({}, buttonProps), {
      toolbars: settings.insertToolbars || [TOOLBARS.FOOTER, TOOLBARS.SIDE, TOOLBARS.MOBILE],
      modalStyles: modalStylesByToolbar[TOOLBARS.FOOTER],
      modalStylesFn: ({ buttonRef, toolbarName }) => {
        return getBottomToolbarModalStyles(
          buttonRef,
          {
            customStyles: DESKTOP_FLY_OUT_MODAL_STYLES,
            isMobile
          },
          toolbarName
        );
      }
    }),
    __spreadProps(__spreadValues({}, buttonProps), {
      toolbars: [TOOLBARS.INSERT_PLUGIN],
      modalStyles: modalStylesByToolbar[TOOLBARS.INSERT_PLUGIN]
    })
  ];
};

export { createInsertButtons as default };
//# sourceMappingURL=insert-buttons.js.map
